import React from 'react';
import {Col, Row} from "reactstrap";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import appLib from "../../../../../libs/appLib.mjs";

const MailEditorBody = class extends React.Component {
	constructor(props) {
		super(props);
		const m = props.message || {};
		this.state = {
			message: m,
			value: m.body || ''
		};
		this.onChange = this.onChange.bind(this);
	}
	onChange = (v) => {
		const m = this.props.getter();
		m.body = v;
		m.html = true;
		this.setState( { value: v, message: m });
		this.props.setter( m );
	};
	render() {
		return(
			<Row>
				<Col>
					<ReactQuill
						theme="snow"
						modules={{toolbar: appLib.toolbarOptions()}}
						value={ this.state.value }
						onChange={ this.onChange }
					/>
				</Col>
			</Row>
		)
	}
};

export default MailEditorBody;
